import { Badge, IconButton } from '@material-ui/core';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { webPushSubscriptionSelector } from 'app/main/apps/webPush/ducks/webPush.selector';
import { setNotificationWebPushDialog } from 'app/main/apps/webPush/ducks/webPush.slice';
import { showMessage } from 'app/store/fuse/messageSlice';
import { isSafariOnMac } from 'app/utils/string.utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const NotificationButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    data: subscription,
    isLoading: isSubscriptionLoading,
    hasError: hasSubscriptionError,
  } = useSelector(webPushSubscriptionSelector);

  const requestNotificationPermission = async () => {
    if (typeof Notification !== 'undefined') {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        dispatch(showMessage({ message: t('notification.errors.isDenied', { ns: 'notification' }), variant: 'error' }));
        return;
      }
    }

    if (!isSubscriptionLoading && !hasSubscriptionError) {
      dispatch(setNotificationWebPushDialog({ isOpen: true }));
    }
  };

  if (isSafariOnMac(navigator.userAgent)) {
    return null;
  }

  return (
    <IconButton onClick={requestNotificationPermission}>
      <Badge color="primary" variant="dot" invisible={!!subscription}>
        {subscription ? <NotificationsIcon /> : <AddAlertIcon />}
      </Badge>
    </IconButton>
  );
};

export default NotificationButton;
